/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { axiosInstance, decodeAtob, isEmptyData } from '../../utils/helper';
import { apiUrlB2B } from '../../utils/constants';
import qs from 'qs';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/reducers/user';
import { setCompany } from "../../store/reducers/ufood-x/company";
import { GEOLOCATION_PERMISSION } from '../../utils/constants';

const useVerify = () => {
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);

	const queryParams = new URLSearchParams(window.location.search);
	const verify = queryParams.get('verify');

	const handleVerify = async (tokenVerify) => {
		console.log('verify');
		try {
			setIsLoading(true);
			const data = {
				tokenVerify: tokenVerify,
			};

			const res = await axiosInstance.post(`${apiUrlB2B}auth-ufoodx/verify`, qs.stringify(data));
			if (res?.data?.statusCode === 200) {
				const { token, refreshToken, customerData } = res?.data?.data;

				const dataCustomer = decodeAtob(customerData);
				const parseCustomer = JSON.parse(dataCustomer);

				const userData = {
					firstName: parseCustomer?.firstName,
					lastName: parseCustomer?.lastName,
					email: parseCustomer?.email,
					primary_phone: parseCustomer?.primary_phone,
					customerID: parseCustomer?.customerID,
					companyID: parseCustomer?.companyID,
					companyName: parseCustomer?.companyName,
					paymentMethod: parseCustomer?.paymentMethod?.toLowerCase(),
          birthDate: parseCustomer?.birthDate,
          gender: parseCustomer?.customerGender,
          status: parseCustomer?.customerStatus || 'P',
				};
				dispatch(
					setUser({
						...userData,
						token: token,
						refresh_token: refreshToken,
						is_b2b: true,
						device: null,
						location_permission: GEOLOCATION_PERMISSION.PROMPT,
						permission: null,
					}),
				);

        if (Boolean(parseCustomer?.loyalty)) {
          const companyData = {
            companyLoyaltyPassword: parseCustomer?.companyLoyaltyPassword,
            companyLoyaltyUrl: parseCustomer?.companyLoyaltyUrl,
            companyLoyaltyUsername: parseCustomer?.companyLoyaltyUsername,
            loyalty: parseCustomer?.loyalty,
            companyLoyaltyWidgetUrl: parseCustomer?.companyLoyaltyWidgetUrl,
            companyLoyaltyClientCode: parseCustomer?.companyLoyaltyClientCode,
          };
          dispatch(setCompany(companyData));
        }
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (isEmptyData(verify)) return;
		handleVerify(verify);
	}, [verify]);

	return { isLoading };
};

export default useVerify;
